import _styled from "@emotion/styled/base";
import { tokens } from '@datacamp/waffles/tokens';

var Label = _styled("span", {
  target: "ed34rxs0",
  label: "Label"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme === 'dark' ? tokens.colors.greyMedium : tokens.colors.navy,
    marginRight: 6
  };
}, "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zb2xlL0xhYmVsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRYyIsImZpbGUiOiIuLi8uLi9zcmMvY29uc29sZS9MYWJlbC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB0b2tlbnMgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy90b2tlbnMnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBDb2RlRWRpdG9yVGhlbWUgfSBmcm9tICcuLi90eXBlcyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTGFiZWxQcm9wcyB7XG4gIHRoZW1lOiBDb2RlRWRpdG9yVGhlbWU7XG59XG5jb25zdCBMYWJlbCA9IHN0eWxlZC5zcGFuPExhYmVsUHJvcHM+KCh7IHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHtcbiAgICBjb2xvcjogdGhlbWUgPT09ICdkYXJrJyA/IHRva2Vucy5jb2xvcnMuZ3JleU1lZGl1bSA6IHRva2Vucy5jb2xvcnMubmF2eSxcbiAgICBtYXJnaW5SaWdodDogNixcbiAgfTtcbn0pO1xuXG5leHBvcnQgeyBMYWJlbCB9O1xuIl19 */");

export { Label };